// @flow
import * as React from 'react';
import type { Answer } from 'models';
import { EditAnswer } from './EditAnswer';
import { ButtonGroup } from 'components';
import { AnswerEditingContext } from 'containers/answer-editing/AnswerEditingContext';
import { ErrorAlert } from 'components/alerts';
import { Article } from './QAComponents';

function renderErrorMessage(err: Error, action: string) {
  if (typeof err.status === 'number' && err.status === 403) {
    return 'You do not have the necessary permissions to make this change.';
  }

  return `An error occurred while ${action} the answer.`;
}

type OwnProps = {
  ugc: Answer,
  viewContext: 'Question' | 'Answer',
  parentUgcId: UgcId,
  subject: Product,
  locale: string,
  allowMedia: boolean,
};
type ContextProps = {
  displayState: string,
  requestStatus: ?RequestStatus,
  onDelete: *,
  onStartEdit: *,
  onCancelEdit: *,
  onSubmitEdit: *,
};
type Props = OwnProps & ContextProps;

class Component extends React.Component<Props> {
  handleStartEdit = () => {
    this.props.onStartEdit(this.props.ugc.ugc_id);
  };

  handleCancelEdit = () => {
    this.props.onCancelEdit(this.props.ugc.ugc_id);
  };

  handleSubmitEdit = ({ answer_media, deleted_media, text }) => {
    const { ugc, viewContext, parentUgcId, subject, locale } = this.props;
    this.props.onSubmitEdit({
      text,
      answer_media,
      deleted_media,
      ugc_id: ugc.ugc_id,
      target: viewContext,
      ugc_type: 'Answer',
      parent_ugc_id: parentUgcId,
      subject_id: subject.subject_id,
      catalog_id: subject.merchant.id,
      locale,
    });
  };

  handleDelete = () => {
    if (window.confirm('Delete answer?')) {
      const { ugc, viewContext, parentUgcId, subject, locale } = this.props;

      this.props.onDelete({
        ugc_id: ugc.ugc_id,
        target: viewContext,
        ugc_type: 'Answer',
        parent_ugc_id: parentUgcId,
        subject_id: subject.subject_id,
        catalog_id: subject.merchant.id,
        locale,
      });
    }
  };

  render() {
    const { ugc, displayState, requestStatus, allowMedia } = this.props;

    if (displayState === 'edit') {
      const isLoading = requestStatus === 'pending';
      const error =
        requestStatus instanceof Error
          ? renderErrorMessage(requestStatus, 'editing')
          : null;

      return (
        <EditAnswer
          ugc={ugc}
          isLoading={isLoading}
          error={error}
          onSubmit={this.handleSubmitEdit}
          onCancel={this.handleCancelEdit}
          allowMedia={allowMedia}
        />
      );
    }

    const aside = ugc.expert ? (
      <div className="mt2">
        <ButtonGroup>
          <button onClick={this.handleStartEdit}>Edit</button>
          <button onClick={this.handleDelete}> Delete </button>
        </ButtonGroup>
      </div>
    ) : null;

    if (displayState === 'view') {
      return <Article ugc={ugc} aside={aside} />;
    } else if (displayState === 'delete') {
      return (
        <div
          style={{
            opacity: requestStatus === 'pending' ? 0.4 : 1,
            pointerEvents: requestStatus === 'pending' ? 'none' : 'auto',
          }}
        >
          {requestStatus instanceof Error && (
            <ErrorAlert>
              {renderErrorMessage(requestStatus, 'deleting')}
            </ErrorAlert>
          )}
          <Article ugc={ugc} aside={aside} />
        </div>
      );
    }

    return null;
  }
}

export const AnswerArticle = (props: OwnProps) => {
  return (
    <AnswerEditingContext.Consumer>
      {value => {
        const {
          state,
          onStartEdit,
          onCancelEdit,
          onSubmitEdit,
          onDelete,
        } = value;
        const { type = 'view', requestStatus } = state.get(
          props.ugc.ugc_id,
          {}
        );

        return (
          <Component
            {...props}
            displayState={type}
            requestStatus={requestStatus}
            onStartEdit={onStartEdit}
            onCancelEdit={onCancelEdit}
            onSubmitEdit={onSubmitEdit}
            onDelete={onDelete}
          />
        );
      }}
    </AnswerEditingContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/AnswerArticle.js